/* HPN Listicle - Proof Blocks Carousel */
(() => {
  if (window.__hpnListicleProofBlocksLoaded) return;
  window.__hpnListicleProofBlocksLoaded = true;

  const ROOT_SELECTOR = '[data-hpn-listicle-proof-carousel]';
  const MOBILE_BREAKPOINT = 989;

  function getRoots(scope = document) {
    const roots = [];

    if (scope instanceof Element && scope.matches(ROOT_SELECTOR)) {
      roots.push(scope);
    }

    roots.push(...scope.querySelectorAll(ROOT_SELECTOR));
    return roots;
  }

  function setActiveDot(track, slides, dots) {
    if (window.innerWidth > MOBILE_BREAKPOINT) {
      dots.forEach((dot) => dot.classList.remove('is-active'));
      return;
    }

    let closestIndex = 0;
    let closestDistance = Infinity;

    slides.forEach((slide, index) => {
      const distance = Math.abs(slide.offsetLeft - track.scrollLeft);

      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = index;
      }
    });

    dots.forEach((dot, index) => {
      const isActive = index === closestIndex;
      dot.classList.toggle('is-active', isActive);
      dot.setAttribute('aria-current', isActive ? 'true' : 'false');
    });
  }

  function buildDots(root, track, slides) {
    const dotsWrap = root.querySelector('[data-hpn-listicle-proof-dots]');
    if (!dotsWrap || !track || !slides.length) return null;

    dotsWrap.innerHTML = '';

    slides.forEach((slide, index) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'hpn-listicle-proof-reviews__dot';
      dot.setAttribute('aria-label', `Go to review ${index + 1}`);
      dot.setAttribute('aria-current', 'false');

      dot.addEventListener('click', () => {
        track.scrollTo({
          left: slide.offsetLeft,
          behavior: 'smooth',
        });
      });

      dotsWrap.appendChild(dot);
    });

    const dots = Array.from(
      dotsWrap.querySelectorAll('.hpn-listicle-proof-reviews__dot')
    );

    let frameId = null;

    const update = () => {
      if (frameId !== null) {
        window.cancelAnimationFrame(frameId);
      }

      frameId = window.requestAnimationFrame(() => {
        setActiveDot(track, slides, dots);
        frameId = null;
      });
    };

    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();

    return () => {
      track.removeEventListener('scroll', update);
      window.removeEventListener('resize', update);

      if (frameId !== null) {
        window.cancelAnimationFrame(frameId);
      }
    };
  }

  function initSection(root) {
    if (!root || root.dataset.hpnListicleProofInitialized === 'true') return;

    const track = root.querySelector('[data-hpn-listicle-proof-track]');
    const slides = track
      ? Array.from(track.querySelectorAll('[data-hpn-listicle-proof-slide]'))
      : [];

    if (!track || !slides.length) return;

    root.dataset.hpnListicleProofInitialized = 'true';
    root.__hpnListicleProofCleanup = buildDots(root, track, slides);
  }

  function destroySection(root) {
    if (!root) return;

    if (typeof root.__hpnListicleProofCleanup === 'function') {
      root.__hpnListicleProofCleanup();
    }

    delete root.__hpnListicleProofCleanup;
    delete root.dataset.hpnListicleProofInitialized;
  }

  function init(scope = document) {
    getRoots(scope).forEach(initSection);
  }

  document.addEventListener('DOMContentLoaded', () => init());

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    getRoots(event.target).forEach(destroySection);
  });

  if (document.readyState !== 'loading') {
    init();
  }
})();
